/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Action_LabelInputs */

const en_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Subtitles`)
};

const fr_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer les sous-titres`)
};

const de_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel importieren`)
};

const it_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa sottotitoli`)
};

const ru_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт субтитров`)
};

const es_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar subtítulos`)
};

const zh_cn2_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入字幕`)
};

const ja_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕をインポートする`)
};

const hi_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक आयात करें`)
};

const pt_pt2_subtitle_import_action_label = /** @type {(inputs: Subtitle_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar legendas`)
};

/**
* | output |
* | --- |
* | "Import Subtitles" |
*
* @param {Subtitle_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_action_label = /** @type {((inputs?: Subtitle_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_action_label(inputs)
	if (locale === "de") return de_subtitle_import_action_label(inputs)
	if (locale === "it") return it_subtitle_import_action_label(inputs)
	if (locale === "ru") return ru_subtitle_import_action_label(inputs)
	if (locale === "es") return es_subtitle_import_action_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_action_label(inputs)
	if (locale === "ja") return ja_subtitle_import_action_label(inputs)
	if (locale === "hi") return hi_subtitle_import_action_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_action_label(inputs)
	return en_subtitle_import_action_label(inputs)
});